module.exports = {
    API_TITLE:"许钦松艺术基金会官网", //项目名称
    testdomainName:"https://api.xuqinsong-art.org.cn/", //测试域名
    domainName:"https://api.xuqinsong-art.org.cn/", //正式域名
    interfacePrefix:"front/", //接口前缀
    port:8033, //本地端口
    assetsPublicPath:"/", //打包后服务器文件路径
    
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 21